import { OfferNetworkProvider } from "@redotech/cockroachdb-codegen/tables/marketing/offer-network-provider";
import { offerPlacementSummarySchema } from "@redotech/order-tracking-common/offer-network/offer-placement";
import * as z from "zod";

/**
 * Discriminated so only providers with a mutable per-placement setting can be
 * updated at all. Rokt's placement is merchant-entered and Uptick's derives
 * from its surface, so neither has anything to change — and neither compiles.
 * A provider that gains a setting adds a variant here and a case in the handler.
 */
export const updateOfferPlacement = {
  name: "updateOfferPlacement" as const,
  input: z.discriminatedUnion("provider", [
    z.object({
      provider: z.literal(OfferNetworkProvider.Falcon),
      placementId: z.string().min(1),
      isLiveMode: z.boolean(),
    }),
  ]),
  output: z.object({ placement: offerPlacementSummarySchema }),
};
